import React from "react";

import { YesNoQuestion } from "@aclymatepackages/modules";

const ElectricIntensityYesNoQuestion = ({
  questionText,
  isElectricCarbonIntensityGiven,
  editIsElectricCarbonIntensityGiven,
  disabled,
}) => (
  <YesNoQuestion
    question={questionText}
    value={isElectricCarbonIntensityGiven}
    setValue={editIsElectricCarbonIntensityGiven}
    disabled={disabled}
  />
);
export default ElectricIntensityYesNoQuestion;
